import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ListFraccionamientoComponent} from './list-fraccionamiento/list-fraccionamiento.component';
import {FormFraccionamientoComponent} from './form-fraccionamiento/form-fraccionamiento.component';


const routes: Routes = [
  {
    path: '',
    component: ListFraccionamientoComponent,
    pathMatch: 'full'
  },
  {
    path: 'ver',
    component: FormFraccionamientoComponent
  },
  {
    path: 'modificar',
    component: FormFraccionamientoComponent
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FraccionamientoRoutingModule {
}
